import { createFileRoute } from "@tanstack/react-router";
import { listAthleteQuestionnaireSubmissions } from "api-client";

import { loaderHandler } from "src/lib/loaderHandler";
import { AthleteQuestionnaireSubmissionsPage } from "src/pages/AthleteQuestionnaireSubmissionsPage";

export const Route = createFileRoute(
  "/_auth/_athlete/questionnaire-submissions/",
)({
  component: AthleteQuestionnaireSubmissionsPage,
  ssr: true,
  async loader() {
    return await loaderHandler(async () => {
      const questionnaireSubmissions =
        await listAthleteQuestionnaireSubmissions().then((response) => {
          return response.data.data;
        });

      return {
        data: {
          questionnaireSubmissions,
        },
      };
    });
  },
});
